import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import PrivateRoute from "./helpers/PrivateRoute";
import styles from "./styles/styles.module.scss";
import { PortalLayout } from "./layouts/PortalLayout";
import AccountDataPage from "./pages/account/AccountDataPage";
import { ForbiddenPage } from "./pages/forbidden/ForbiddenPage";
import { ContentAlert } from "./helpers/ContentAlert";
import { NotFoundPage } from "./pages/notfound/NotFoundPage";
import { FixKeycloakUrl } from "./helpers/FixKeycloakUrl";
function App() {
    return React.createElement("div", { className: styles.appContent },
        React.createElement(HashRouter, null,
            React.createElement(FixKeycloakUrl, null),
            React.createElement(Routes, null,
                React.createElement(Route, { element: React.createElement(PortalLayout, null) },
                    React.createElement(Route, { element: React.createElement(PrivateRoute, null) },
                        React.createElement(Route, { path: "/", element: React.createElement(AccountDataPage, null) })),
                    React.createElement(Route, { path: "/forbidden", element: React.createElement(ForbiddenPage, null) }),
                    React.createElement(Route, { path: "*", element: React.createElement(NotFoundPage, null) })))),
        React.createElement(ContentAlert, null));
}
export default App;
